
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * AuthenticationType enum
 */
class AuthenticationType {
  /**
   * Initialize enum with a given value
   * @param {AuthenticationType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof AuthenticationType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!AuthenticationType}
   * @param {!AuthenticationType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AuthenticationType)) {
      throw new TypeError('Instance of AuthenticationType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!AuthenticationType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!AuthenticationType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === AuthenticationType.PBKDF2.value) {
      return 'PBKDF2'
    }
    if (this.value === AuthenticationType.BCRYPT.value) {
      return 'BCRYPT'
    }
    if (this.value === AuthenticationType.SCRYPT.value) {
      return 'SCRYPT'
    }
    if (this.value === AuthenticationType.ARGON2.value) {
      return 'ARGON2'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!AuthenticationType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!AuthenticationType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!AuthenticationType} Created enum
   */
  static fromObject (other) {
    return new AuthenticationType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
AuthenticationType.PBKDF2 = new AuthenticationType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
AuthenticationType.BCRYPT = new AuthenticationType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
AuthenticationType.SCRYPT = new AuthenticationType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
AuthenticationType.ARGON2 = new AuthenticationType(0 + 3)

export { AuthenticationType };

/**
 * Fast Binary Encoding AuthenticationType field model
 */
class FieldModelAuthenticationType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelAuthenticationType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelAuthenticationType}
   * @param {AuthenticationType=} defaults Default value, defaults is new AuthenticationType()
   * @returns {!AuthenticationType} Result value
   */
  get (defaults = new AuthenticationType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new AuthenticationType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelAuthenticationType}
   * @param {!AuthenticationType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelAuthenticationType };
